// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"ea7ef407","99":"8c210c97","146":"64a55eb5","175":"7c75489c","204":"34303541","349":"7abd0a3f","479":"4901045e","655":"6eaa2c88","674":"dd309f0d","768":"3b5b60ac","813":"e2f8e44d","963":"2abb720f"}[chunkId] + ".chunk.js";
};